

import { createSlice } from '@reduxjs/toolkit';
import { broadcastLogin, resetLogoutFlag } from 'src/api/axiosInstance';
import { checkAuth, fetchUserRoles, initializeUserSession, loginUser, logoutUser, refreshAvailableRoles } from '../thunks/authThunks';


// --- authSlice ---
const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: false,
        loading: true,
        error: null,
        user: null,
        sites: [],
        userRoles: [],
        csrfToken: null,  // add this
        isInitialized: false,  // <-- ADD THIS
        isSessionLoaded: false, // tracks whether initializeUserSession has completed
    },
    reducers: {

        setUserRoles: (state, action) => {
            state.userRoles = action.payload;
        },
        localLogout(state) {
            state.isAuthenticated = false;
            state.user = null;
            state.sites = [];
            state.userRoles = [];
            state.csrfToken = null;
            state.error = null;
            state.loading = false;
            state.isInitialized = true;
            state.isSessionLoaded = true;
        }

    },
    extraReducers: (builder) => {
        builder
            // --- checkAuth ---
            .addCase(checkAuth.pending, (state) => {
                state.loading = true;
            })
            .addCase(checkAuth.fulfilled, (state) => {
                state.isAuthenticated = true;
                state.loading = false;
                state.isInitialized = true; // <-- SET HERE
            })
            .addCase(checkAuth.rejected, (state) => {
                state.isAuthenticated = false;
                state.loading = false;
                state.isInitialized = true; // <-- EVEN ON FAIL
            })

            // --- loginUser ---
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            // .addCase(loginUser.fulfilled, (state, action) => {
            //     resetLogoutFlag(); // keep this

            //     // Only mark authenticated when payload includes an accessToken (final successful login)
            //     if (action.payload && action.payload.accessToken) {
            //         state.isAuthenticated = true;
            //     } else {
            //         // OTP flow (202) or other intermediate responses — do not mark authenticated yet
            //         state.isAuthenticated = false;
            //     }

            //     state.loading = false;
            // })
            .addCase(loginUser.fulfilled, (state, action) => {
                resetLogoutFlag(); // keep this

                // Final successful login ONLY. Cookie auth responses may not include accessToken.
                if (action.payload?.user || action.payload?.accessToken) {
                    state.isAuthenticated = true;

                    // Notify other tabs so duplicated tabs switch to the latest logged-in user.
                    broadcastLogin();
                } else {
                    // OTP flow or intermediate states
                    state.isAuthenticated = false;
                }

                state.loading = false;
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.isAuthenticated = false;
                state.error = action.payload;
                state.loading = false;
            })

            // --- initializeUserSession ---
            .addCase(initializeUserSession.pending, (state) => {

                state.loading = true;
            })
            .addCase(initializeUserSession.fulfilled, (state, action) => {

                state.isAuthenticated = true;
                state.loading = false;
                state.user = action.payload.user;
                state.sites = action.payload.sites;
                state.error = null;
                state.isSessionLoaded = true;
            })
            .addCase(refreshAvailableRoles.fulfilled, (state, action) => {
                state.sites = action.payload;
            })
            .addCase(initializeUserSession.rejected, (state, action) => {
                state.isAuthenticated = false;
                state.loading = false;
                state.error = action.payload;
                state.isSessionLoaded = true;
            })

            // --- fetchUserRoles ---
            .addCase(fetchUserRoles.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchUserRoles.fulfilled, (state, action) => {
                state.userRoles = action.payload;
                state.loading = false;
            })
            .addCase(fetchUserRoles.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            })
            .addCase(logoutUser.fulfilled, (state) => {
                state.isAuthenticated = false;
                state.user = null;
                state.sites = [];
                state.userRoles = [];
                state.error = null;
                state.loading = false;
                // Keep isSessionLoaded = true so guards can immediately evaluate
                // isAuthenticated = false and redirect to login, instead of showing
                // an infinite loading screen waiting for initializeUserSession.
                state.isSessionLoaded = true;
            })
            .addCase(logoutUser.rejected, (state, action) => {
                state.isAuthenticated = false;
                state.user = null;
                state.sites = [];
                state.userRoles = [];
                state.error = action.payload;
                state.loading = false;
                state.isSessionLoaded = true;
            })

    },
});

// --- exports ---
export const { setUserRoles, localLogout } = authSlice.actions;
export default authSlice.reducer;
